<template>
  <div class="main-page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="rev-head">Review and Book</div>

    <div class="rev-page">
      <div class="rev-hero">
        <img :src="blockData.ProductImage">
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <div class="hero-badge">Attraction</div>
          <div class="hero-title">{{ blockData.ProductName }}</div>
          <div class="hero-meta">
            <span v-if="blockData.Destination">
              <i class="fas fa-map-marker-alt fa-fw"></i>
              {{ blockData.Destination }}
            </span>
            <span v-if="blockData.Duration.trim()">
              <i class="far fa-clock fa-fw"></i>
              {{ blockData.Duration }}
            </span>
          </div>
        </div>
      </div>

      <div class="info-bar">
        <div class="info-card" v-if="blockData.Duration.trim()">
          <div class="info-icon">
            <i class="far fa-clock fa-fw"></i>
          </div>
          <div>
            <label>Duration</label>
            <p>{{ blockData.Duration }}</p>
          </div>
        </div>
        <div class="info-card">
          <div class="info-icon">
            <i class="far fa-calendar fa-fw"></i>
          </div>
          <div>
            <label>Booking Date</label>
            <p>{{ formatDate(blockData.BookingDate) }}</p>
          </div>
        </div>
        <div class="info-card">
          <div class="info-icon">
            <i class="fas fa-users fa-fw"></i>
          </div>
          <div>
            <label>Travelers</label>
            <p>{{ filters.travellers.total }}</p>
          </div>
        </div>
        <!-- <div class="info-card">
          <div class="info-icon">
            <i class="far fa-file-alt fa-fw"></i>
          </div>
          <div>
            <label>Voucher Type</label>
            <p>Printed Voucher</p>
          </div>
        </div> -->
      </div>

      <div class="rev-two-col">
        <div class="rev-two-main">
          <div class="section-box">
            <div class="sb-header">
              <div class="sb-icon">
                <i class="fas fa-info-circle fa-fw"></i>
              </div>
              <label>About This Experience</label>
            </div>
            <div class="description-text" v-html="blockData.GradeDescription"></div>
          </div>

          <div class="section-box">
            <div class="sb-header">
              <div class="sb-label">
                <div class="sb-icon">
                  <i class="fas fa-user fa-fw"></i>
                </div>
                <label>Customer Information</label>
              </div>
              <div class="sb-account" v-if="_token">
                Welcome <b>{{user.firstName}}</b>!
                (Not <b>{{user.firstName}}</b>? <a @click="logout"><b>Logout</b></a>)
              </div>
            </div>
            

            <div class="pax-form" v-for="(pax, p) in paxForm.adult.slice(0, 1)" :key="p">
              <!-- <div class="pax-sub-header">Adult #{{ p + 1 }}</div> -->

              <div class="d-flex pax-fields align-start">
                <div :class="['pax-field', {'has-error':paxErrorFields.adult.indexOf(`title${p}`) > -1}]">
                  <div class="pax-field-label">Title</div>
                  <select v-model="pax[`title${p}`]" class="pax-title no-outline">
                    <option value="">--</option>
                    <option value="Mr">Mr.</option>
                    <option value="Ms">Ms.</option>
                    <option value="Mrs">Mrs.</option>
                    <option value="Miss">Miss</option>
                    <option value="Mstr">Mstr</option>
                  </select>
                </div>

                <div :class="['pax-field fw', {'has-error':paxErrorFields.adult.indexOf(`firstName${p}`) > -1}]">
                  <div class="pax-field-label">First name<span>*</span></div>
                  <input type="text" placeholder="First Name"
                    v-model="pax[`firstName${p}`]"
                    class="no-outline" />
                </div>

                <div :class="['pax-field fw', {'has-error':paxErrorFields.adult.indexOf(`lastName${p}`) > -1}]">
                  <div class="pax-field-label">Last name<span>*</span></div>
                  <input type="text" placeholder="Last Name"
                    v-model="pax[`lastName${p}`]"
                    class="no-outline" />
                </div>
              </div>

              <div :class="['pax-field fw', {'has-error':paxErrorFields.adult.indexOf(`email${p}`) > -1}]" v-if="p === 0" style="margin-bottom: 20px;">
                <div class="pax-field-label">Email address<span>*</span></div>
                <input type="text" placeholder="Email"
                  v-model="pax[`email${p}`]"
                  class="no-outline" />
              </div>

              <div class="pax-field fw" v-if="p === 0">
                <div class="pax-field-label">Mobile number<span>*</span></div>
                <mobile-input :needVerification="false" :mobile="pax[`mobile${p}`]"
                  @updateMobile="pax[`countryCode${p}`] = $event.countryCode; pax[`mobile${p}`] = $event.mobile; highlightCheck()" :dialCode="pax[`countryCode${p}`]" :forPax="true" :uniqID="'mobile2'"
                  :required="true" :hasError="paxErrorFields.adult.indexOf(`mobile${p}`) > -1"
                  class="no-outline"></mobile-input>
              </div>
            </div>

          </div>

          <div class="section-box" v-if="blockData.BookingQuestions && blockData.BookingQuestions.length">
            <div class="sb-header">
              <div class="sb-icon">
                <i class="fas fa-info-circle fa-fw"></i>
              </div>
              <label>Additional Information</label>
            </div>

            <div class="question-forms">
              <div class="q-field" v-for="question in blockData.BookingQuestions">
                <div class="q-label">{{ question.subTitle.toLowerCase() }}</div>
                <input type="text" class="q-value" />
              </div>
            </div>
          </div>

          <payment-form ref="paymentForm" class="payment-form-box"
            @done="paymentDone" @changeCard="changeCard"></payment-form>

          <div class="price-section">
            <div class="price-label">Total Price</div>
            <div class="price-value">
              {{ currencySymbol[currency.code] }}
              {{ applyCurrency(blockData.Price, false) }} 
              <span>{{ currency.code }}</span>
            </div>
            <div class="price-note">Total for {{ filters.travellers.total }} traveler • Taxes included</div>
            <button class="km-btn" @click="initBook">Book Now</button>
          </div>
        </div>

        <div class="rev-two-side">
          <div class="side-card" v-if="blockData.TM_Cancellation_Charge && blockData.TM_Cancellation_Charge.length">
            <div class="side-label">
              <i class="far fa-check-circle fa-fw"></i>
              Cancellation Policy
            </div>
            <div class="c-row" v-for="cxl in blockData.TM_Cancellation_Charge">
              <span class="c-date">{{ cxlDate(cxl) }}</span>
              <span :class="['c-fee', cxl.Charge ? 'paid' : 'free']">{{ cxlFee(cxl) }}</span>
            </div>
            <!-- <div class="c-row">
              <span class="c-date">Jun 15 – Jun 16, 2026</span>
              <span class="c-fee paid">100% Charge</span>
            </div> -->
            <div class="c-deadline" v-if="blockData.TM_LastCancellation_date">
              Last free cancellation: <strong>{{ formatDate(blockData.TM_LastCancellation_date) }}</strong>
            </div>
          </div>

          <div class="side-card">
            <div class="side-label">Provider Details</div>
            <div class="supplier-row">
              <span class="s-label">Provider</span>
              <span class="s-value">FlyOver Las Vegas</span>
            </div>
            <div class="supplier-row">
              <span class="s-label">Supplier</span>
              <span class="s-value">HotelBeds USA, Inc</span>
            </div>
            <div class="supplier-row">
              <span class="s-label">Product Code</span>
              <span class="s-value" style="font-size:12px;">E-U10-A1GMNO0129</span>
            </div>
            <div class="supplier-row">
              <span class="s-label">Grade</span>
              <span class="s-value">TICKET1</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import { customAlphabet } from 'nanoid'
import mobileInput from '@/components/D2DReview/MobileInput'
import paymentForm from '@/components/D2DReview/PaymentForm'
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'review-page',
  components: { mobileInput, paymentForm },
  data () {
    return {
      paxForm: {
        adult: [],
        children: [],
        infants: []
      },
      paxErrorFields: {
        adult: [],
        children: [],
        infants: []
      },
      currencySymbol: currencySymbol,
      appRef: '',
      sightseeingBookingId: '',
      submitting: false
    }
  },
  computed: {
    user () { return this.$store.state.user },
    _token () { return this.user.token },
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    sightSeeing () { return this.$store.state.sightSeeing },
    view () { return this.sightSeeing.view },
    tripData () { return this.sightSeeing.trips },
    blockData () { return this.sightSeeing.block },

    things () { return this.$store.state.things },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/sight-seeing/trips')
    },
    submitBlock () {
      let self = this
      if (self.submitting) return
      self.submitting = true
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/sightseeing/payment`, {
        token: self.user.token,
        cardId: self.$store.state.selectedCard.id,
        credits: self.$store.state.credits,
        displayCurrency: self.currency.code,
        displayPrice: self.applyCurrency(self.blockData.Price, false, true),
        displayFinal: self.applyCurrency(self.blockData.Price, false, true),
        details: {
          BlockTrip: {BlockTripResult: self.blockData}
        },
        selected: self.tripData.selected
      }, r => {
        if (r.error) {
          self.submitting = false
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.sightseeingBookingId = r.sightseeingBookingId
        self.submitBook()
      })
    },
    submitBook () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})

      self.appRef = self.buildAppReference()
      let pax = []
      let paxType = ['adult', 'children', 'infants']
      let email = ''
      let ContactNo = ''
      paxType.forEach(pt => {
        self.filters.travellers.info[pt].forEach((p, i) => {
          let PaxType = 1
          if (pt === 'children') PaxType = 2
          if (pt === 'infants') PaxType = 3
          let countryPhoneCode = self.filters.travellers.info.adult[0][`countryCode0`] || ''
          if (countryPhoneCode && countryPhoneCode.toString().indexOf('+') > -1) {
            countryPhoneCode = parseInt(countryPhoneCode.toString().substring(1))
          }
          if (!ContactNo && self.filters.travellers.info.adult[0][`mobile0`]) ContactNo = self.sanitizeInput(`${countryPhoneCode}${self.filters.travellers.info.adult[0][`mobile0`]}`)
          if (!email && self.filters.travellers.info.adult[0][`email0`]) email = self.filters.travellers.info.adult[0][`email0`]
          pax.push({
            Title: self.filters.travellers.info.adult[0][`title0`],
            FirstName: self.filters.travellers.info.adult[0][`firstName0`],
            LastName: self.filters.travellers.info.adult[0][`lastName0`],
            Phoneno: ContactNo,
            Email: email,
            PaxType: PaxType,
            LeadPassenger: 1
          })
        })
      })
      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/book`, {
        AppReference: self.appRef,
        BlockTourId: self.blockData.BlockTourId,
        PassengerDetails: pax,
        ProductDetails: {
          ProductCode: self.blockData.ProductCode,
          BookingDate: self.blockData.BookingDate,
          GradeCode: self.blockData.GradeCode,
          hotelId: '',
          pickupPoint: ''
        },
        BookingQuestions: []
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status) {
          self.submitting = false
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('sightSeeing/setData', {commit: r.CommitBooking})
        // self.$store.commit('sightSeeing/setData', {commit: {}})
        // self.$router.push('/sight-seeing/thankyou')
        self.saveBook()
      })
    },
    saveBook () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/sightseeing/book`, {
        token: self.user.token,
        sightseeingBookingId: self.sightseeingBookingId,
        AppReference: self.appRef,
        details: {CommitBooking: self.sightSeeing.commit}
      }, r => {
        self.submitting = false
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$router.push('/sight-seeing/thankyou')
      })
    },
    buildAppReference () {
      let ts = moment().format('x')
      let nanoid = customAlphabet('0123456789', 10)
      let result = 'FB' + ts.substring(0, 2) + '-' + ts.substring(2, 8) + '-' + ts.substring(8) + nanoid(1)
      return result
    },
    sanitizeInput (x) {
      return x.replace(/[\u202A-\u202E]/g, '')
    },
    checkPax () {
      if (this.filters.travellers.info.adult.length && this.filters.travellers.info.adult[0].firstName0) {
        this.paxForm = this.filters.travellers.info
      } else {
        this.setupPax()
      }
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          if (this.user.title) tmpObj.title0 = this.user.title
          if (this.user.gender) {
            tmpObj.gender0 = this.user.gender
            if (this.user.gender === 'Male') tmpObj.gender0 = 1
            if (this.user.gender === 'Female') tmpObj.gender0 = 2
          }
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
      this.paxForm = paxForm
    },
    cxlDate (x) {
      if (!x) return ''
      let from = moment(x.FromDate, 'YYYY-MM-DD').format('MMM DD')
      let to = moment(x.ToDate, 'YYYY-MM-DD').format('MMM DD, YYYY')
      return `${from} - ${to}`
    },
    cxlFee (x) {
      if (!x) return ''
      if (!x.Charge) return 'Free'
      return `${x.Charge}% Charge`
    },
    formatDate (x) {
      if (!x) return ''
      return moment(x, 'YYYY-MM-DD').format('MMMM DD, YYYY')
    },
    price (data) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.TotalDisplayFare
      if (data.Currency !== 'USD' && this.currency.code !== data.Currency) {
        x = x / this.currency.list[data.Currency]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: data.Currency,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    changeCard (x) {
      this.$store.commit('setSelectedCard', {id: x})
    },
    paymentDone (res) {
      if (!this.paxErrorFields.adult.length && res) {
        this.submitBlock()
        return
      }
      this.$store.commit('global/setLoaderData', {show: false})
    },
    initBook () {
      this.paxErrorFields.adult = []
      if (!this.paxForm.adult[0].title0) this.paxErrorFields.adult.push('title0')
      if (!this.paxForm.adult[0].firstName0) this.paxErrorFields.adult.push('firstName0')
      if (!this.paxForm.adult[0].lastName0) this.paxErrorFields.adult.push('lastName0')
      if (!this.paxForm.adult[0].email0) this.paxErrorFields.adult.push('email0')
      if (!this.paxForm.adult[0].mobile0) this.paxErrorFields.adult.push('mobile0')

      this.$store.commit('global/setLoaderData', {show: true})
      if (this.$refs.paymentForm) this.$refs.paymentForm.submitForm()
    },
    logout () {
      this.$store.commit('global/setLogoutData', {show: true})
    }
  },
  watch: {
    _token (val) {
      if (!val) {
        this.$store.commit('global/setAuthData', {
          show: true,
          action: 'forceAuth'
        })
      } else {
        this.setupPax()
      }
    }
  },
  mounted () {
    if (!this.view) {
      this.$router.push('/search')
      return
    }
    this.checkPax()
  }
}
</script>

<style lang="scss" scoped>
.main-page-box{
  // background: #fafafa;
  // border: 1px solid #ddd;
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover{
    color: #ff9c09;
  }
}

.rev-head{
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 5px;
  text-align: left;
  font-size: 32px;
  font-weight: 700;
  color: #1a1a2e;
}

.rev-hero{
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  img{
    width: 100%;
    height: 420px;
    object-fit: cover;
    display: block;
  }
}
.hero-overlay{
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.85) 0%, rgba(26, 26, 46, 0.2) 50%, transparent 100%);
}
.hero-content{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 40px;
}
.hero-badge{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ECAE20;
  color: #1a1a2e;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 14px;
  border-radius: 30px;
  margin-bottom: 16px;

  &::before{
    content: '';
    width: 6px;
    height: 6px;
    background: #1a1a2e;
    border-radius: 50%;
  }
}
.hero-title{
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
  line-height: 1.2;
}
.hero-meta{
  display: flex;
  align-items: center;
  gap: 20px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  flex-wrap: wrap;
  letter-spacing: .4px;
}

.info-bar{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.info-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid #ffe19c;
  transition: transform 0.2s, box-shadow 0.2s;

  label{
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #8892a0;
    margin-bottom: 4px;
  }
  p{
    font-size: 15px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0!important;
  }
}
.info-icon{
  width: 44px;
  height: 44px;
  background: rgba(236, 174, 32, 0.12);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i{
    color: #ECAE20;
  }
}

.rev-two-col{
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}
.section-box{
  background: #fff;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;
}
.sb-header{
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  label{
    font-size: 18px;
    font-weight: 700;
    color: #1a1a2e;
  }
}
.sb-label{
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.sb-account{
  text-align: right;
  width: 100%;
}
.sb-icon{
  width: 36px;
  height: 36px;
  background: rgba(236, 174, 32, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  i{
    color: #ECAE20;
  }
}
.description-text{
  font-size: 15px;
  color: #4a4a6a;
  line-height: 1.8;
}

.rev-two-side > *{
  margin-bottom: 24px;
}
.side-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.side-label{
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  i{
    color: #22c55e;
  }
}
.c-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f6;
}
.c-date{
  font-size: 13px;
  color: #8892a0;
}
.c-fee{
  font-size: 14px;
  font-weight: 600;

  &.free{
    color: #22c55e;
  }
  &.paid{
    color: #ef4444;
  }
}
.c-deadline{
  margin-top: 16px;
  padding: 12px 16px;
  background: rgba(236, 174, 32, 0.08);
  border-radius: 10px;
  font-size: 13px;
  color: #1a1a2e;
  font-weight: 500;
}
.supplier-row{
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f3f6;
  font-size: 14px;

  .s-label{
    color: #8892a0;
  }
  .s-value{
    font-weight: 600;
    color: #1a1a2e;
  }
  &:last-child{
    border-bottom: none;
  }
}

.pax-form{
  padding: 10px 0 20px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;

  &:last-child{
    border:none;
  }
  .pax-sub-header{
    font-weight: 600;
    color: #1a1a2e;
    line-height: 1;
    margin-bottom: 15px;
  }
  .pax-fields{
    gap: 15px;
    margin-bottom: 10px;
  }
}
.pax-field-label{
  color: #8892a0;
  font-size: 13px;
  line-height: 1;
  letter-spacing: .7px;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 4px;
}
.pax-field{
  margin-bottom: 10px;

  &.fw{
    width: 100%
  }
  select{
    padding: 10px;
    border: 1px solid #bbb;
    min-width: 100px;
  }
  input{
    padding: 11px 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
  }
  &.has-error{
    input,
    select{
      border:1px solid #EB5837;
    }
  }
}

.q-field{
  margin-bottom: 12px;
}
.q-label{
  color: #8892a0;
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: .7px;
  text-transform: capitalize;
  font-weight: 600;
  margin-bottom: 4px;
}
.q-value{
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  background: #fafafa;
  border-radius: 4px;
}

.price-section {
  background: #1a1a2e;
  border-radius: 10px;
  padding: 32px;
  color: #fff;
  position: relative;
  overflow: hidden;
}
.price-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}
.price-value {
  font-size: 42px;
  font-weight: 700;
  color: #ECAE20;
  margin-bottom: 4px;
  position: relative;
  z-index: 1;

  span {
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    margin-left: 4px;
  }
}
.price-note {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 24px;
  word-spacing: 2px;
  letter-spacing: .6px;
}
.km-btn {
  width: 100%;
  padding: 16px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  z-index: 1;
}


@media only screen and (max-width: 641px) {
  .back-box{
    padding-left: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?2c7be00f